import React from "react";
import { twMerge } from "tailwind-merge";

export interface IPropsButton extends React.ComponentProps<'button'> {
    name?: any;
    label?: string;
    size?: number | `${number}` | undefined;
    labelSize?: string;
    transparent?: boolean;
    left?: boolean;
    right?: boolean;
}

const Button: React.FC<IPropsButton> = ({
    transparent,
    left,
    right,
    name,
    label,
    labelSize,
    size,
    ...props
}) => {

    const icon = {
        backgroundImage: `url(${name})`,
        backgroundSize: 'cover',
        height: size || 18,
        width: size || 18
    };
    return (
        <button
            {...props}
            className={twMerge(
                "flex gap-[10px] items-center justify-center uppercase bg-[#31883A] text-white font-medium border border-gray-300 rounded-lg p-1.5 px-5 hover:bg-green-800",
                transparent && "bg-black/20 rounded-l-lg hover:bg-white/10",
                // left && transparent ? "bg-black/20 rounded-l-lg hover:bg-white/10"
                //     : right && transparent ? "bg-black/20 rounded-r-lg hover:bg-white/10"
                //         : "bg-white/10 rounded-lg hover:bg-black/5",
                // props.disabled && "flex gap-[10px] items-center bg-white/10 border border-white/10 rounded-lg p-1.5 px-5 opacity-50 hover:bg-white/10",
                props.className
            )}
        >
            {
                name &&
                <div style={icon} />
            }
            {label && <span className={labelSize ? labelSize : "text-xs"}>{label}</span>}
        </button>
    )
}

export default Button;